<template>
  <p class="a-input-wrapper-column">
    <label
      v-if="label"
      :for="$attrs.name"
    >
      {{ label }}
    </label>
    <span class="a-input-group-primary">
      <span>{{ spanInput }}</span>
      <input
        :value="value"
        v-bind="$attrs"
        :class="inputError ? 'a-input-primary a-input-danger' : 'a-input-primary'"
        spellcheck="false"
        v-on="listeners"
        :ref="reference"
        @input="updateValue"
      />
    </span>
    <small class="font-weight-bold text-color-academy-primary">
      {{ messageWarning }}
    </small>
    <small
      v-if="!inputError && message"
      class="font-weight-light"
    >
      <i>{{ message }}</i>
    </small>
    <small
      v-if="inputError"
      class="text-color-danger"
    >
      {{ messageError }}
    </small>
  </p>
</template>

<script>
export default {
  name: 'AtomInputGroupPrimary',
  inheritAttrs: false,

  props: {
    inputError: Boolean,
    label: String,
    message: String,
    messageError: String,
    messageWarning: String,
    reference: String,
    spanInput: String,
    value: [Number, String]
  },

  computed: {
    listeners () {
      return {
        ...this.$listeners,
        input: this.updateValue
      }
    }
  },

  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>
